/**
 * EfaxDialog - Send Document via eFax Dialog Component
 * Extracted from ClientDetailPage
 */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function EfaxDialog({
  open,
  onOpenChange,
  efaxData,
  setEfaxData,
  sendingEfax,
  onSendEfax,
}) {
  const getDocumentTypeName = (type) => {
    switch(type) {
      case "cms485": return "CMS 485 Form";
      case "md_order": return "MD Order";
      case "care_plan_poc": return "Care Plan POC";
      default: return "Document";
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Send Document via Fax</DialogTitle>
          <DialogDescription>
            Fax this document to a physician or facility
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Recipient Fax Number *</Label>
            <Input
              placeholder="+12025551234"
              value={efaxData.recipient_fax}
              onChange={(e) => setEfaxData(prev => ({ ...prev, recipient_fax: e.target.value }))}
            />
            <p className="text-xs text-slate-500">E.164 format required (e.g., +12025551234)</p>
          </div>
          <div className="space-y-2">
            <Label>Recipient Name *</Label>
            <Input
              placeholder="Dr. John Smith"
              value={efaxData.recipient_name}
              onChange={(e) => setEfaxData(prev => ({ ...prev, recipient_name: e.target.value }))}
            />
          </div>
          <div className="space-y-2">
            <Label>Document Type</Label>
            <Input
              value={getDocumentTypeName(efaxData.document_type)}
              disabled
              className="bg-slate-50"
            />
          </div>
          <div className="space-y-2">
            <Label>Notes (Optional)</Label>
            <Textarea
              placeholder="Any additional notes for this fax..."
              value={efaxData.notes}
              onChange={(e) => setEfaxData(prev => ({ ...prev, notes: e.target.value }))}
              rows={2}
            />
          </div>
          <label
            className="flex items-start gap-2 p-3 rounded-lg border cursor-pointer transition-colors border-slate-200 hover:bg-slate-50 has-[:checked]:border-red-300 has-[:checked]:bg-red-50"
            data-testid="efax-urgent-toggle"
          >
            <input
              type="checkbox"
              className="mt-0.5 accent-red-600"
              checked={!!efaxData.urgent}
              onChange={(e) => setEfaxData(prev => ({ ...prev, urgent: e.target.checked }))}
            />
            <span className="text-sm">
              <span className="font-medium text-slate-900">Mark as URGENT</span>
              <span className="block text-xs text-slate-600">
                Adds a red URGENT stamp and banner to the cover sheet so the
                receiving office prioritises it.
              </span>
            </span>
          </label>
          <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="text-xs text-amber-800">
              <strong>Note:</strong> Fax will be dispatched via your active provider (eFax / SRFax). If credentials aren&apos;t configured or the physician has no fax on file, the request will be queued for manual processing.
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onSendEfax} disabled={sendingEfax}>
            {sendingEfax ? "Sending..." : "Send Fax"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
